import "./DashboardPieCard.css";

import { ReactNode } from "react";

import { Card, PieChart, PieChartCenterTextFont, PieChartColors } from "../../../../widget";

export interface DashboardPieCardProps {
  data: { [key: string]: number };
  title: string;
  centerTextSuffix?: string;
  size?: number;
  corners?: "rounded" | "default";
  colours?: PieChartColors;
  noDataMessage?: string;
  tooltip?: ReactNode;
  showValues?: boolean;
  isGradient?: boolean;
  centerTextFont?: PieChartCenterTextFont;
  chartColorsOverride?: string[][];
}

export const DashboardPieCard = ({
  data,
  title,
  centerTextSuffix,
  size = 120,
  corners = "default",
  colours = "default",
  noDataMessage,
  tooltip,
  showValues = true,
  isGradient = false,
  centerTextFont = "Space Grotesk",
  chartColorsOverride,
}: DashboardPieCardProps): JSX.Element => {
  return (
    <Card height="100%" corners={corners}>
      <div className="DashboardPieCardContainer">
        <div className="DashboardPieCardHeader">
          <p className="body01">{title}</p>
          <div>{tooltip}</div>
        </div>
        <div className="DashboardPieCardContent">
          <PieChart
            size={size}
            data={data}
            centerTextSuffix={centerTextSuffix}
            noDataMessage={noDataMessage}
            colors={colours}
            showValues={showValues}
            isGradient={isGradient}
            centerTextFont={centerTextFont}
            chartColorsOverride={chartColorsOverride}
          />
        </div>
      </div>
    </Card>
  );
};
